import { chatEE } from '@/layout/events/chat-event-emitter';
import { Authorize } from '@/shared/components/authorize';
import { IosShareOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import type { FC } from 'react';
import type { Message } from '../../models/message';

interface MenuForwardItemProps {
  msg: Message;
  onClose: () => void;
}

export const ForwardMenuItem: FC<MenuForwardItemProps> = ({ msg, onClose }) => {
  const handleForwardClick = () => {
    chatEE.emit('message-forward', msg);
    onClose(); // Close the menu
  };

  return (
    <Authorize conversationId={msg.conversationId} permissions={['MESSAGE_SEND']}>
      <MenuItem onClick={handleForwardClick}>
        <ListItemIcon>
          <IosShareOutlined />
        </ListItemIcon>
        <ListItemText>Chuyển tiếp</ListItemText>
      </MenuItem>
    </Authorize>
  );
};
